import * as React from 'react';
import { useTheme } from 'styled-components';

function SvgComponent(props: React.SVGProps<SVGSVGElement> & { color: string }) {
	const theme = useTheme() as any;

	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.148 2.384a1 1 0 011.704 0l6.21 10.092A1 1 0 0114.21 14H1.79a1 1 0 01-.852-1.524l6.21-10.092zM7 5a1 1 0 012 0v4a1 1 0 01-2 0V5zm1 8a1 1 0 100-2 1 1 0 000 2z"
				fill={theme.colors[props.color]}
			/>
		</svg>
	);
}

export default SvgComponent;
